module.exports = __webpack_public_path__ + "img/slide6.9379605d.png";